import { Link, useParams } from "react-router-dom";
import { ShellTopBar } from "../shell/ShellTopBar";
import "./LegalDocPage.css";

const TITLES: Record<string, string> = {
  "user-agreement": "用户协议",
  privacy: "隐私政策",
  compliance: "法律合规",
  creator: "大V入驻规则",
};

/** 法规占位页，正文可后续接 CMS 或静态 HTML */
export default function LegalDocPage() {
  const { slug = "" } = useParams<{ slug: string }>();
  const title = TITLES[slug] ?? "文档";

  return (
    <div className="legal-doc-layout">
      <ShellTopBar />
      <div className="legal-doc-page">
        <p className="legal-doc-back">
          <Link to="/">返回首页</Link>
        </p>
        <h1 className="legal-doc-h1">{title}</h1>
        <p className="legal-doc-p">正文待补充。</p>
      </div>
    </div>
  );
}
